import { render, staticRenderFns } from "./Live_Podiums.vue?vue&type=template&id=183a8aae&"
import script from "./Live_Podiums.vue?vue&type=script&lang=js&"
export * from "./Live_Podiums.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports